import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { LinearProgress } from 'material-ui/Progress'
import withStyles from 'material-ui/styles/withStyles'

const PROP_TYPES = {
  classes: PropTypes.object.isRequired,
  infoText: PropTypes.string,
  isDialog: PropTypes.bool
}

const styles = theme => ({
  root: {
    left: '50%',
    position: 'absolute',
    top: '45%',
    width: 300,
  },
  infoText: {
    display: 'inline-block',
    marginBottom: 5
  }
})

export class LoadingIndicator extends Component {

  render() {
    const { classes, infoText, isDialog } = this.props

    return (
      <div className={isDialog ? null : classes.root}>
        <span id="loading-text" className={isDialog ? null : classes.infoText}>{infoText}</span>
        <br />
        <LinearProgress data-test-id="progress-indicator" />
      </div>
    )
  }
}

LoadingIndicator.propTypes = PROP_TYPES

export default withStyles(styles)(LoadingIndicator)
